import { oauthAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const microsoftAzure = defineConnector({
  identifier: "microsoftAzure",
  name: "Microsoft Azure",
  tagLine: "Microsoft cloud services",
  logo,
  protocol: "http",
  tags: ["featured", "it", "engineering"],
  defaultUrlPattern: () => "https://management\\.azure\\.com/.*",
  auth: oauthAuth,
  steps: [
    {
      title: "Register an application in Azure AD",
      items: [
        {
          kind: "markdown",
          content:
            "Visit the [Azure Portal](https://portal.azure.com/#view/Microsoft_AAD_RegisteredApps/ApplicationsListBlade) and register a new application.\n\nUnder **Certificates & secrets**, create a new client secret and copy it.",
        },
      ],
    },
    {
      title: "Enter your Azure credentials",
      items: [
        {
          kind: "input",
          label: "Tenant ID",
          placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          required: true,
          target: { kind: "configuration", field: "tenantId" },
          helperText: "Found in Azure AD → Overview → Tenant ID",
        },
        {
          kind: "input",
          label: "Client ID",
          placeholder: "xxxxxxxx-xxxx-xxxx-xxxx-xxxxxxxxxxxx",
          required: true,
          target: { kind: "oauthConnection", field: "clientId" },
          helperText:
            "Found in App registrations → Your app → Application (client) ID",
        },
        {
          kind: "input",
          label: "Client secret",
          placeholder: "Your client secret value",
          required: true,
          target: { kind: "oauthConnection", field: "clientSecret" },
        },
      ],
    },
  ],
  oauth: {
    grantType: () => "client_credentials",
    tokenEndpoint: ({ tenantId }) =>
      `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/token`,
    scopes: () => ["https://management.azure.com/.default"],
    clientCredentialsFrom: "db",
    tokenEndpointAuthMethod: () => "client_secret_post",
  },
  connectionTest: {
    protocol: "http",
    request: () =>
      "https://management.azure.com/subscriptions?api-version=2022-12-01",
  },
  publicEnvVars: ({ tenantId }): Record<string, string> => ({
    AZURE_TENANT_ID: tenantId || "",
    AZURE_CLIENT_ID: "",
    AZURE_CLIENT_SECRET: "{will-be-injected}",
  }),
});
